import { CDN_CLRSAVE_URL } from '../constants';

export const NAV_LINKS = [
  {
    label: 'Dashboard',
    key: '/dashboard',
    link: true,
    href: '/save/dashboard/portfolio',
    icon: `${CDN_CLRSAVE_URL}/clearsave-frontend/images/dashboard-icon-v3.svg`,
    subLinksLoading: true,
    subLinks: null,
  },
  {
    label: 'Profile',
    key: '/profile',
    link: true,
    href: '/save/profile',
    icon: `${CDN_CLRSAVE_URL}/clearsave-frontend/images/my-account1.svg`,
    subLinks: null,
  },
];

export const MOBILE_NAV_LINKS = [
  {
    label: 'Dashboard',
    key: '/dashboard',
    link: true,
    href: '/save/dashboard/portfolio',
    subLinks: null,
    icon: `${CDN_CLRSAVE_URL}/clearsave-frontend/images/dashboard-icon-v3.svg`,
  },

  {
    loading: true,
  },

  {
    loading: true,
  },
];

export const PROFILE_LINK = {
  label: 'Profile',
  key: '/profile',
  link: true,
  href: '/save/profile',
  subLinks: null,
  icon: `${CDN_CLRSAVE_URL}/clearsave-frontend/images/my-account1.svg`,
};

export const KYC_LINK = {
  label: 'Finish KYC',
  key: '/complete-kyc',
  link: true,
  href: '/save/complete-kyc',
  status: 'PENDING',
  subLinks: null,
  icon: `${CDN_CLRSAVE_URL}/clearsave-frontend/images/my-account1.svg`,
};

export const VERIFY_MANDATE_LINK = {
  label: 'Set up Mandate',
  key: '/mandate',
  link: true,
  href: '/save/mandate',
  status: 'PENDING',
  subLinks: null,
  icon: `${CDN_CLRSAVE_URL}/clearsave-frontend/images/help-icon.svg`,
};

export const PENNY_DROP_LINK = {
  label: 'Bank Verification',
  key: '/profile',
  link: true,
  href: '/save/profile',
  status: 'PENDING',
  subLinks: null,
  icon: `${CDN_CLRSAVE_URL}/clearsave-frontend/images/help-icon.svg`,
};

export const LIST_MANDATE_LINK = {
  label: 'View Mandate Status',
  key: '/mandate-status',
  link: true,
  href: '/save/mandate-status',
  icon: `${CDN_CLRSAVE_URL}/clearsave-frontend/images/help-icon.svg`,
  subLinks: null,
};

export const CREATE_MANDATE = {
  label: 'Create Mandate',
  key: '/create-mandate',
  link: true,
  href: '/save/mandate',
  icon: `${CDN_CLRSAVE_URL}/clearsave-frontend/images/help-icon.svg`,
  subLinks: null,
};



// WEBPACK FOOTER //
// ./constants/sidenav.ts